<div class="translate d-flex gap-1" (click)="onTranslation()">
  <img src="assets/img/translate-icon.svg" />
  <span *ngIf="!translatingOnSamePage">{{ translateLabel }}</span>
  <span *ngIf="translatingOnSamePage">{{ translateLabelSamePage }}</span>
</div>
